import EditIcon from '@mui/icons-material/Edit';
import { alpha, Box, IconButton } from '@mui/material';

export interface EditCardMediaEditorHoverOverlayProps {
  editorUrl: string;
  children: React.ReactNode;
}

/**
 * Same hover pattern as the rendered-video play overlay: full-area hit target on hover
 * reveals a circular control; opens the video editor (same destination as EditCardEditorButton).
 */
export function EditCardMediaEditorHoverOverlay({
  editorUrl,
  children,
}: EditCardMediaEditorHoverOverlayProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        isolation: 'isolate',
        '&:hover': {
          cursor: 'pointer',
        },
        '&:hover .edit-card-media-editor-overlay': {
          opacity: 1,
        },
      }}
    >
      {children}
      <IconButton
        component="a"
        href={editorUrl}
        rel="noopener noreferrer"
        className="edit-card-media-editor-overlay"
        size="large"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          margin: 0,
          borderRadius: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          opacity: 0,
          transition: (theme) =>
            theme.transitions.create('opacity', { duration: theme.transitions.duration.shorter }),
          zIndex: 2,
          '&:hover': {
            bgcolor: (theme) => alpha(theme.palette.common.black, 0.15),
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.main',
            bgcolor: 'background.paper',
            boxShadow: 2,
            borderRadius: '50%',
            width: (theme) => theme.spacing(7),
            height: (theme) => theme.spacing(7),
          }}
        >
          <EditIcon />
        </Box>
      </IconButton>
    </Box>
  );
}
